import { createContext } from "react";

type ErrorContextType = {
  showError: (message: any) => void;
};

export const ErrorContext = createContext<ErrorContextType>({
  showError: () => {},
});